var map = {
	"./Ansar.svg": [
		"./src/assets/banks/Ansar.svg",
		"src_assets_banks_Ansar_svg"
	],
	"./Ayandeh.svg": [
		"./src/assets/banks/Ayandeh.svg",
		"src_assets_banks_Ayandeh_svg"
	],
	"./Bank_Markazi.svg": [
		"./src/assets/banks/Bank_Markazi.svg",
		"src_assets_banks_Bank_Markazi_svg"
	],
	"./Caspian.svg": [
		"./src/assets/banks/Caspian.svg",
		"src_assets_banks_Caspian_svg"
	],
	"./Dey.svg": [
		"./src/assets/banks/Dey.svg",
		"src_assets_banks_Dey_svg"
	],
	"./Eghtesad_Novin.svg": [
		"./src/assets/banks/Eghtesad_Novin.svg",
		"src_assets_banks_Eghtesad_Novin_svg"
	],
	"./Futurebank.svg": [
		"./src/assets/banks/Futurebank.svg",
		"src_assets_banks_Futurebank_svg"
	],
	"./Gardeshgari.svg": [
		"./src/assets/banks/Gardeshgari.svg",
		"src_assets_banks_Gardeshgari_svg"
	],
	"./Ghavamin.svg": [
		"./src/assets/banks/Ghavamin.svg",
		"src_assets_banks_Ghavamin_svg"
	],
	"./Hekmat.svg": [
		"./src/assets/banks/Hekmat.svg",
		"src_assets_banks_Hekmat_svg"
	],
	"./Iran_Europe.svg": [
		"./src/assets/banks/Iran_Europe.svg",
		"src_assets_banks_Iran_Europe_svg"
	],
	"./Iran_Venezuela.svg": [
		"./src/assets/banks/Iran_Venezuela.svg",
		"src_assets_banks_Iran_Venezuela_svg"
	],
	"./Iran_Zamin.svg": [
		"./src/assets/banks/Iran_Zamin.svg",
		"src_assets_banks_Iran_Zamin_svg"
	],
	"./Karafarin.svg": [
		"./src/assets/banks/Karafarin.svg",
		"src_assets_banks_Karafarin_svg"
	],
	"./Keshavarzi.svg": [
		"./src/assets/banks/Keshavarzi.svg",
		"src_assets_banks_Keshavarzi_svg"
	],
	"./Khavar_Mianeh.svg": [
		"./src/assets/banks/Khavar_Mianeh.svg",
		"src_assets_banks_Khavar_Mianeh_svg"
	],
	"./Kosar.svg": [
		"./src/assets/banks/Kosar.svg",
		"src_assets_banks_Kosar_svg"
	],
	"./Maskan.svg": [
		"./src/assets/banks/Maskan.svg",
		"src_assets_banks_Maskan_svg"
	],
	"./Mehr_Eghtesad.svg": [
		"./src/assets/banks/Mehr_Eghtesad.svg",
		"src_assets_banks_Mehr_Eghtesad_svg"
	],
	"./Mehr_Iran.svg": [
		"./src/assets/banks/Mehr_Iran.svg",
		"src_assets_banks_Mehr_Iran_svg"
	],
	"./Melall.svg": [
		"./src/assets/banks/Melall.svg",
		"src_assets_banks_Melall_svg"
	],
	"./Mellat.svg": [
		"./src/assets/banks/Mellat.svg",
		"src_assets_banks_Mellat_svg"
	],
	"./Melli.svg": [
		"./src/assets/banks/Melli.svg",
		"src_assets_banks_Melli_svg"
	],
	"./Noor.svg": [
		"./src/assets/banks/Noor.svg",
		"src_assets_banks_Noor_svg"
	],
	"./Parsian.svg": [
		"./src/assets/banks/Parsian.svg",
		"src_assets_banks_Parsian_svg"
	],
	"./Pasargad.svg": [
		"./src/assets/banks/Pasargad.svg",
		"src_assets_banks_Pasargad_svg"
	],
	"./Postbank.svg": [
		"./src/assets/banks/Postbank.svg",
		"src_assets_banks_Postbank_svg"
	],
	"./Refah.svg": [
		"./src/assets/banks/Refah.svg",
		"src_assets_banks_Refah_svg"
	],
	"./Resalat.svg": [
		"./src/assets/banks/Resalat.svg",
		"src_assets_banks_Resalat_svg"
	],
	"./Saderat.svg": [
		"./src/assets/banks/Saderat.svg",
		"src_assets_banks_Saderat_svg"
	],
	"./Saman.svg": [
		"./src/assets/banks/Saman.svg",
		"src_assets_banks_Saman_svg"
	],
	"./Sanat_Madan.svg": [
		"./src/assets/banks/Sanat_Madan.svg",
		"src_assets_banks_Sanat_Madan_svg"
	],
	"./Sarmayeh.svg": [
		"./src/assets/banks/Sarmayeh.svg",
		"src_assets_banks_Sarmayeh_svg"
	],
	"./Sepah.svg": [
		"./src/assets/banks/Sepah.svg",
		"src_assets_banks_Sepah_svg"
	],
	"./Shahr.svg": [
		"./src/assets/banks/Shahr.svg",
		"src_assets_banks_Shahr_svg"
	],
	"./Sina.svg": [
		"./src/assets/banks/Sina.svg",
		"src_assets_banks_Sina_svg"
	],
	"./Standard_Chartered.svg": [
		"./src/assets/banks/Standard_Chartered.svg",
		"src_assets_banks_Standard_Chartered_svg"
	],
	"./Taavon_Eslami.svg": [
		"./src/assets/banks/Taavon_Eslami.svg",
		"src_assets_banks_Taavon_Eslami_svg"
	],
	"./Tejarat.svg": [
		"./src/assets/banks/Tejarat.svg",
		"src_assets_banks_Tejarat_svg"
	],
	"./Tosee.svg": [
		"./src/assets/banks/Tosee.svg",
		"src_assets_banks_Tosee_svg"
	],
	"./Tosee_Saderat.svg": [
		"./src/assets/banks/Tosee_Saderat.svg",
		"src_assets_banks_Tosee_Saderat_svg"
	],
	"./Tosee_Taavon.svg": [
		"./src/assets/banks/Tosee_Taavon.svg",
		"src_assets_banks_Tosee_Taavon_svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/assets/banks lazy recursive ^\\.\\/.*\\.svg$";
module.exports = webpackAsyncContext;